import { render } from "./integrationsOauthApplications.vue?vue&type=template&id=a0b2e5d2&scoped=true"
import script from "./integrationsOauthApplications.vue?vue&type=script&lang=js"
export * from "./integrationsOauthApplications.vue?vue&type=script&lang=js"

import "./integrationsOauthApplications.vue?vue&type=style&index=0&id=a0b2e5d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b2e5d2"]])

export default __exports__